export default __webpack_public_path__ + "static/media/favicon.1c3dca94.ico";